// Loaded by snippets/players-selection-sidebar.liquid via
// {{ 'sizing-chart.js' | asset_url | script_tag }}.
//
// This header exists to make git see a change, and that is not as silly as it sounds.
// This file went missing from the LIVE theme while being present and correct in the
// repo: it used to ship as sizing-chart.js.liquid, which Shopify serves under the same
// asset key, and when that twin was deleted in 0c6dd4ab the integration removed the
// asset from the theme. It never uploaded this file in its place, because git had no
// change to push for it — the last real edit was 2025-03-05. The result was a 404
// serving Shopify's HTML error page, a "MIME type ('text/html') is not executable"
// console error, and no sizing chart on the storefront, for weeks.
//
// Beware the same trap elsewhere: assets/fhs.lbl.js and assets/shopstorm-apps.js each
// still sit beside a .js.liquid twin. Deleting either twin will delete the live asset.
var productTags = [];
var productIds = [];
var boldBundleChanged = false;
if(page == "players-selection-sidebar" && typeof productDetail != "undefined" && productDetail != null) {
  	productTags = productDetail.tags;
}
$('#AddToCartForm-product-sz-template').bind('DOMSubtreeModified', function(){
  if(!boldBundleChanged && $(".sizing-chart-bundle").length > 0) {
    boldBundleChanged = true;
    productTags = ['bundle'];
    $(".sizing-chart-bundle").each(function() {
      var productId = $(this).closest(".bold-bundles-child-product").find(".bold-product-variant").attr("data-bold-variant");
      productIds.push(productId);
      $(this).attr("data-prodId", productId);
	});
    sizingChart();
  }
});


function showSizingChart(productId) {
  
 var productIds = [];
 //productIds.push(productId);
  productTags = [];
  currentProductTag = $(".sizing-chart-"+productId).attr("tags");
  if (currentProductTag != "") {
  	productTags = currentProductTag.split(',');
  }

  // alert(productId);
 // alert('80th line');
  
  // var clubPrice = appBaseUrl+"api/sizing-chart?productTags="+JSON.stringify(productTags)+"&productIds="+JSON.stringify(productIds);
  var clubPrice = appBaseUrl + "api/sizing-chart?productTags=" + encodeURIComponent(JSON.stringify(productTags)) + "&productIds=" + encodeURIComponent(JSON.stringify(productIds));
  // alert(clubPrice);
  $.ajax({
      type:'GET',
      url: clubPrice,
      dataType: "jsonp",
      error: function(xhr, status, error) {

      },
  });
  setTimeout(
  function() 
  {
    $(".sizing-chart-"+productId).trigger("click");
  }, 2000);
  
  
}

$(function() {
    sizingChart();
});

function sizingChart() {
  var clubPrice = appBaseUrl + "api/sizing-chart?productTags=" + encodeURIComponent(JSON.stringify(productTags)) + "&productIds=" + encodeURIComponent(JSON.stringify(productIds));
  $.ajax({
      type:'GET',
      url: clubPrice,
      dataType: "jsonp",
      error: function(xhr, status, error) {

      },
  });
}

var tagsContent = {};
function sizingChartUpdate(response) {
  	tagsContent = response;
  	$('.sizing-chart').each(function(){
      	var tags = $(this).attr("tags");
      var tagsList = typeof tags != "undefined" ? tags.split(',') : [];
      	
        for(var i = 0; i < tagsList.length; i++) {
          console.log(tagsList[i] in response);
          if(tagsList[i] in response) {
            $(this).removeClass("d-none");
            break;
          }
        }
    });
}

function bundlrSizingChartUpdate(response) {
  console.log("bundle response");
  var products = response.products;
  tagsContent = response.tagsContent;
  for (var key in products) {
     var tags = products[key];
     $('.sizing-chart-bundle').each(function(){
       if($(this).attr("data-prodId") == key) {
         if(tagsContent.hasOwnProperty(key)) {
           $(this).removeClass("d-none");
         }
         
         $(this).attr("tags", tags);
       }
     });
  }
  
}

$(document).on("click",".sizing-chart",function() {
  	var tags = $(this).attr("tags");
  	var tagsList = tags.split(',');
  	var inc = 0;
  	for(var i = 0; i < tagsList.length; i++) {
      var tag = tagsList[i].trim();
      if(tag in tagsContent) {
        inc++;
      }
    }
  
  	var content = "";
  	var active = true;
    for(var i = 0; i < tagsList.length; i++) {
      var tag = tagsList[i].trim();
      if(tag in tagsContent) {
        if(inc === 1) {
          content += `<div>${tagsContent[tag]}</div>`;
        } else {
          var activeItem = active ? "active" : "";
          active = false;
          content += `<div class="carousel-item ${activeItem}">${tagsContent[tag]}</div>`;
        }
        
      }
    }
  
    if(inc > 1) {
        content = `<div id="demo" class="carousel slide" data-ride="carousel">
		<div class="carousel-inner">${content}</div>
          <a class="carousel-control-prev" href="#demo" data-slide="prev">
            <span class="carousel-control-prev-icon"></span>
          </a>
          <a class="carousel-control-next" href="#demo" data-slide="next">
            <span class="carousel-control-next-icon"></span>
          </a>

        </div>`;
    }
  	$("#sizingChartModalLabel").text($(this).attr("title")+" Sizing Chart");
  	$("#sizingChartContent").html(content);
  	$("#sizingChartModal").addClass("show");
});

$(document).on("click","#sizingChartModalClose",function() {
  $("#sizingChartModal").removeClass("show");
});